const mode = 'prod';
export const config = {
    apiURL: mode === 'prod' ? 'https://api.isc-sai.org' : 'http://localhost:3001'
};